import { api } from "@data-phone/react-resource-server-auth";
import { isPossiblePhoneNumber } from "libphonenumber-js";
import qs from "qs";
import { Utils } from "utils";
import { useApiQuery } from "../hooks/useApiQuery";

export interface CallHistoryRequest {
    callUUID: string;
    callDirection: "inbound" | "outbound";
    callerIDNumber: string;
    destination: string;
}

export interface CallHistoryItem {
    id: string;
    direction: "inbound" | "outbound";
    records: any[];
}

const fetchCallHistoryData = async (data: CallHistoryRequest): Promise<CallHistoryItem | undefined> => {
    const othernum = data.callDirection === "inbound" ? data.callerIDNumber : data.destination;
    const ournum = data.callDirection === "inbound" ? data.destination : data.callerIDNumber;

    if (!othernum) {
        return;
    }

    const response = await api.get(`${process.env.REACT_APP_CDR_BASE_API_URL}/cdr?${qs.stringify({
        filters: { othernum,  limit: 5, offset: 0 }, 
    }, { encode: false })}`);

    return { records: response.data.records, direction: data.callDirection, id: data.callUUID };
};

export const useCallHistoryQuery = (request: CallHistoryRequest | null, enabled: boolean = true) => {
    return useApiQuery(
        ['callHistory', request?.callUUID, request?.callDirection, request?.callerIDNumber, request?.destination],
        () => fetchCallHistoryData(request!),
        {
            enabled: enabled && !!request,
            showErrorToast: true,
        }
    );
};

export const fetchCallHistoryLookup = fetchCallHistoryData;
